export default __webpack_public_path__ + "static/media/profile-1.b93e4339.png";